import *  as axios from 'axios';
import * as R from 'ramda';
import * as ActionTypes from '../../constants/actiontypes/funecap/activityLog';
import * as urls from '../../constants/webapi/partner/partner';
import { getAuthenticationUrl } from '../../constants/webapi/auth';

export function fetchActivityLog(partnerId, fromDate, toDate, pageSize = null, operatorId = null, userId = null, continuationToken = null) {
    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_ACTIVITYLOG_REQUEST });
        return axios.get(urls.activityLogByPartnerIdUrl(partnerId, fromDate, toDate, pageSize, operatorId, userId, continuationToken))
            .then((response) => {
                dispatch({
                    type: ActionTypes.FETCH_ACTIVITYLOG_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_ACTIVITYLOG_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}